const LOCAL_PORTS = [8100, 8000];
const AWS_ENDPOINT = "wss://langdetect.duckdns.org/ws";
const AWS_HTTP_BASE = "https://langdetect.duckdns.org";

function productionHttpBase() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/api`;
  }
  return AWS_HTTP_BASE;
}

async function probeHttp(port, timeoutMs = 800) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    // Backend may not have a GET /, but any HTTP response (incl. 404) means it's up
    await fetch(`http://127.0.0.1:${port}/health`, {
      signal: controller.signal,
      mode: "no-cors",
    });
    return true;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}

class ServerDiscovery {
  static async discoverServer() {
    const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (!isDev) {
      console.log('Using server:', AWS_ENDPOINT);
      return AWS_ENDPOINT;
    }

    for (const port of LOCAL_PORTS) {
      if (await probeHttp(port)) {
        const endpoint = `ws://127.0.0.1:${port}/ws`;
        console.log('Using server:', endpoint);
        return endpoint;
      }
    }

    // Nothing answered — return the default and let the caller surface the error
    const fallback = `ws://127.0.0.1:${LOCAL_PORTS[0]}/ws`;
    console.warn('No local backend reachable, falling back to', fallback);
    return fallback;
  }

  /**
   * HTTP base URL (no trailing slash) for REST endpoints like /daily.
   * Mirrors discoverServer() but returns an http(s) origin instead of wss.
   */
  static async discoverHttpBase() {
    const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (!isDev) return productionHttpBase();

    for (const port of LOCAL_PORTS) {
      if (await probeHttp(port)) return `http://127.0.0.1:${port}`;
    }
    // Local UI, remote API — same as production so auth/daily work without a local backend.
    console.warn('No local backend on', LOCAL_PORTS.join('/'), '— using', AWS_HTTP_BASE);
    return AWS_HTTP_BASE;
  }
}

export default ServerDiscovery;
